<template>
  <figure class="rounded-b-lg overflow-hidden max-h-40 h-24 md:h-auto md:rounded-lg">
    <img
      :src="src ? src : '/images/profile-banner-placeholder.jpg'"
      class="rounded-b-lg md:rounded-lg object-cover object-center w-full max-h-40"
    />
  </figure>
</template>

<script>
export default {
  name: 'ProfileBanner',
  props: {
    src: String,
  },
}
</script>

<style></style>
